import React from 'react';
import Icon from 'components/AppIcon';

const ExecutiveMetrics = ({ selectedPeriod, isSecureView }) => {
  const getMetricsData = () => {
    const baseMetrics = [
      {
        id: 1,
        title: "Total Revenue",
        value: isSecureView ? "KES 45,750,000" : "KES ••••••••",
        change: "+22% from last period",
        changeType: "positive",
        icon: "TrendingUp",
        color: "bg-success-50 text-success-600",
        description: "Gross revenue including all practice areas"
      },
      {
        id: 2,
        title: "Profit Margin",
        value: isSecureView ? "68.4%" : "••••%",
        change: "+5.2% improvement",
        changeType: "positive",
        icon: "Target",
        color: "bg-primary-50 text-primary",
        description: "Net profit margin after expenses"
      },
      {
        id: 3,
        title: "Active Cases",
        value: "247",
        change: "+18 new cases",
        changeType: "positive",
        icon: "Briefcase",
        color: "bg-secondary-50 text-secondary-600",
        description: "Total active matters across all partners"
      },
      {
        id: 4,
        title: "Client Satisfaction",
        value: "94.7%",
        change: "+2.1% this period",
        changeType: "positive",
        icon: "Star",
        color: "bg-warning-50 text-warning-600",
        description: "Average client satisfaction rating"
      },
      {
        id: 5,
        title: "Case Win Rate",
        value: "87.3%",
        change: "Above industry average",
        changeType: "positive",
        icon: "Award",
        color: "bg-accent-50 text-accent-600",
        description: "Success rate across all case types"
      },
      {
        id: 6,
        title: "Billing Efficiency",
        value: isSecureView ? "91.2%" : "••••%",
        change: "+4.3% improvement",
        changeType: "positive",
        icon: "Clock",
        color: "bg-info-50 text-info-600",
        description: "Billable hours vs. total hours ratio"
      }
    ];

    return baseMetrics;
  };

  const metrics = getMetricsData();

  const getChangeIcon = (changeType) => {
    switch (changeType) {
      case 'positive': return 'TrendingUp';
      case 'negative': return 'TrendingDown';
      default: return 'Minus';
    }
  };

  const getChangeColor = (changeType) => {
    switch (changeType) {
      case 'positive': return 'text-success';
      case 'negative': return 'text-error';
      default: return 'text-text-secondary';
    }
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-bold text-text-primary">Executive Metrics</h2>
          <p className="text-text-secondary mt-1">
            Key performance indicators for {selectedPeriod} period
          </p>
        </div>
        {!isSecureView && (
          <div className="flex items-center space-x-2 text-warning-600">
            <Icon name="Eye" size={16} />
            <span className="text-sm font-medium">Limited View</span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
        {metrics?.map((metric) => (
          <div key={metric?.id} className="bg-surface rounded-lg shadow-card p-6 border border-border hover:shadow-card-hover transition-smooth">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${metric?.color}`}>
                <Icon name={metric?.icon} size={24} />
              </div>
              <button className="p-1 hover:bg-secondary-100 rounded transition-smooth">
                <Icon name="MoreHorizontal" size={16} className="text-text-secondary" />
              </button>
            </div>
            
            <div className="mb-4">
              <h3 className="text-2xl font-heading font-bold text-text-primary mb-1">
                {metric?.value}
              </h3>
              <p className="text-sm text-text-secondary mb-2">{metric?.title}</p>
              <div className="flex items-center space-x-1">
                <Icon 
                  name={getChangeIcon(metric?.changeType)} 
                  size={12} 
                  className={getChangeColor(metric?.changeType)}
                />
                <span className={`text-xs font-medium ${getChangeColor(metric?.changeType)}`}>
                  {metric?.change}
                </span>
              </div>
            </div>

            <p className="text-xs text-text-secondary leading-relaxed">
              {metric?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExecutiveMetrics;